import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

const API_URL = "https://9vlnpf328i.execute-api.us-east-1.amazonaws.com/prod/sendsms";

const SendScreen: React.FC = () => {
  const [searchParams] = useSearchParams();
  const practice = searchParams.get("practice") || "";

  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<null | "success" | "error">(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(null);
    setErrorMsg("");
    setLoading(true);
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mobile_number: mobile,
          email: email,
          practice_name: practice
        })
      });

      const data = await response.json();
      if (response.ok && !data.error) {
        setStatus("success");
      } else {
        setStatus("error");
        setErrorMsg(data.error || "Unknown error occurred");
      }
    } catch (err: any) {
      setStatus("error");
      setErrorMsg(err.message || "Network error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setMobile("");
    setEmail("");
    setStatus(null);
    setErrorMsg("");
  };

  return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Card className="w-full max-w-xl mx-auto shadow-2xl">
          <CardHeader>
            <CardTitle className="text-3xl font-bold mb-2">Send Sleep Assessment</CardTitle>
          </CardHeader>
          {status === "success" ? (
              <CardContent className="text-green-600 text-lg font-semibold py-8">
                Thank you, your SMS has been sent successfully.
              </CardContent>
          ) : (
              <form onSubmit={handleSend}>
                <CardContent className="flex flex-col gap-6">
                  <div>
                    <Label htmlFor="mobile">Mobile Number</Label>
                    <input
                        id="mobile"
                        type="tel"
                        className="w-full mt-1 rounded-md bg-muted px-4 py-3 outline-none"
                        value={mobile}
                        onChange={e => setMobile(e.target.value)}
                        required
                    />
                  </div>
                  <div>
                    <Label htmlFor="email">Email (Optional)</Label>
                    <input
                        id="email"
                        type="email"
                        className="w-full mt-1 rounded-md bg-muted px-4 py-3 outline-none"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                  </div>
                  {status === "error" && (
                      <div className="text-red-600 font-medium">
                        Sorry, the system has encountered an issue: {errorMsg}
                      </div>
                  )}
                </CardContent>
                <CardFooter className="flex justify-end gap-4 mt-4">
                  <Button
                      type="submit"
                      variant="default"
                      className="px-8 bg-purple-600 hover:bg-purple-700 text-white"
                      disabled={loading}
                  >
                    {loading ? "Sending..." : "Send"}
                  </Button>
                  <Button
                      type="button"
                      variant="secondary"
                      onClick={handleCancel}
                      disabled={loading}
                  >
                    Cancel
                  </Button>
                </CardFooter>
              </form>
          )}
        </Card>
      </div>
  );
};

export default SendScreen;